if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.giftMessageId = this.form.querySelector(".js-gift-message-id");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        this.submitButton = this.querySelector('[type="submit"]');
        this.productBar = this.querySelector(".js-product-bar");
        this.giftMessage = this.getAttribute("data-product-form-gift-message");
        this.parentForm = document.getElementById(
          this.getAttribute("data-product-form-gift-message-parent")
        );
        this.errorMessage = this.querySelector(".js-gift-message-error");

        this.listeners();
      }

      listeners() {
        if (!this.productBar || !this.submitButton) return;

        const handleFormObserver = (mutationList, observer) => {
          mutationList.forEach(mutation => {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1 && node.classList.contains('tpa-product-widget-wrapper')) {
                  this.productBar.classList.add('hidden');
                }
              });
            }
          });
        };
        
        const formObserver = new MutationObserver(handleFormObserver);
        formObserver.observe(this.form, {childList: true,subtree: false});
        
        const toggleBar = () => {
          const submitButtonRect = this.submitButton.getBoundingClientRect();

          if (submitButtonRect.top > 0) {
            this.productBar.classList.remove("active");
          } else {
            this.productBar.classList.add("active");
          }
        };

        window.addEventListener(
          "scroll",
          debounce(() => {
            toggleBar();
          }, 300)
        );

        toggleBar();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.errorMessage?.classList.add("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData = new FormData(this.form);

        if (this.giftMessage && this.parentForm) {
          config.headers["Content-Type"] = "application/json";

          const properties = {
            "__Is Gift": true,
          };
          
          let formOptions = [...this.form.querySelectorAll("[name=id]")];

          const selectedId = formOptions.filter(option => option.checked)[0]
            ? formOptions.filter(option => option.checked)[0].value
            : null;
          const parentSelectedId = this.parentForm.querySelector("[name=id]")
            ? this.parentForm.querySelector("[name=id]").value
            : null;

          if (!selectedId || !parentSelectedId) return;

          const giftMessage = document.querySelector(".js-gift-message")
            ? document.querySelector(".js-gift-message").value
            : null;

          if (!giftMessage) {
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.classList.remove("loading");
            this.errorMessage.classList.remove("hidden");
            return;
          }

          const giftMessageFor = document.querySelector(".js-gift-message-for")
            ? document.querySelector(".js-gift-message-for").value
            : null;
          const giftMessageId = document.querySelector(".js-gift-message-id")
            ? document.querySelector(".js-gift-message-id").value
            : null;

          if (giftMessage) {
            properties["Gift Message"] = giftMessage;
          }

          if (giftMessageFor) {
            properties["For"] = giftMessageFor;
          }

          if (giftMessageId) {
            properties["__Gift Message ID"] = giftMessageId;
          }

          formData = {
            items: [
              {
                id: selectedId,
                quantity: 1,
                properties,
              },
              {
                id: parentSelectedId,
                quantity: 1,
                properties: {
                  "__Is Gift Parent": true,
                  "__Gift Message ID": giftMessageId,
                },
              },
            ],
          };
          config.body = JSON.stringify(formData);
        } else {
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
              document.dispatchEvent(new CustomEvent("cart:added"));
            }

            this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");

            const addButtons = document.querySelectorAll(".js-add-button");
            if (addButtons.length) {
              addButtons.forEach((button) => {
                button.classList.remove("loading");
              });
            }

            this.updateGiftMessageId();
          });
      }

      updateGiftMessageId() {
        if (!this.giftMessageId) return;

        this.giftMessageId.value = Date.now();
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.giftingOptionsAddOns = document.querySelectorAll(
      ".js-gifting-options-add-ons"
    );
    this.giftMessageFor = document.querySelector(".js-gift-message-for");
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, false, false, true);
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updategiftingOptionsAddOns();
    this.updateGiftMessageFor();

    if (!this.currentVariant) {
      this.toggleAddButton(true, false, true, false);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateSlider();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateLinkedForm();
    }
  }

  updateLinkedForm() {
    const linkedForm = document.getElementById(
      this.getAttribute("data-linked-form")
    );

    if (!linkedForm) return;

    const linkedFormId = linkedForm.querySelector("[name=id]");

    if (!linkedFormId) return;

    linkedFormId.value = this.currentVariant.id;
  }

  updateGiftMessageFor() {
    if (!this.giftMessageFor || !this.currentVariant.name) return;
    this.giftMessageFor.value = this.currentVariant.name;
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSlider() {
    const id = this.currentVariant?.featured_media?.id;

    if (id) {
      let sliderIndex;
      let targetSlide = document.querySelector(
        `[id="${this.dataset.section}-product-main-gallery"] [data-id="${id}"]`
      );

      if (targetSlide) {
        sliderIndex = targetSlide.getAttribute("data-index");
      }

      let sliders = document.querySelectorAll(
        `[id="${this.dataset.section}-product-main-gallery"]`
      );

      if (sliderIndex && sliders.length) {
        document.dispatchEvent(
          new CustomEvent("slider:go", {
            detail: {
              index: sliderIndex,
              targetSliders: sliders,
            },
          })
        );
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    const productSection = document.querySelector(".js-product-section");
    if (!productSection) return;
    const addButtons = productSection.querySelectorAll("add-product");
    if (!addButtons.length) return;
    addButtons.forEach((button) => {
      button.setAttribute("data-id", this.currentVariant.id);
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  updategiftingOptionsAddOns() {
    this.giftingOptionsAddOns.forEach((el) => {
      const giftingVariant = el.getAttribute("data-gifting-variant");

      el.classList.remove("active");

      if (this.currentVariant.id == giftingVariant) {
        el.classList.add("active");
      }
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );

        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const propertiesSource = html.getElementById(
          `properties-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const propertiesDestination = document.getElementById(
          `properties-${this.dataset.section}`
        );

        const productBarSource = html.getElementById(
          `Bar-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const productBarDestination = document.getElementById(
          `Bar-${this.dataset.section}`
        );

        if (productBarSource && productBarDestination)
          productBarDestination.innerHTML = productBarSource.innerHTML;

        if (source && destination) destination.innerHTML = source.innerHTML;

        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;

        if (propertiesSource && propertiesDestination)
          propertiesDestination.innerHTML = propertiesSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdatedSource = html.getElementById(
          `ProductSubmitButton-${this.dataset.section}`
        );

        const addButtonUpdatedDestination = document.getElementById(
          `ProductSubmitButton-${this.dataset.section}`
        );

        if (addButtonUpdatedSource && addButtonUpdatedDestination)
          addButtonUpdatedDestination.innerHTML =
            addButtonUpdatedSource.innerHTML;
      });
  }

  toggleAddButton(
    disable = true,
    preorder,
    modifyClass = true,
    loading = false
  ) {
    const productSection = document.querySelector(".js-product-section");
    if (!productSection) return;
    const addButtons = productSection.querySelectorAll(".js-add-button");
    if (!addButtons.length) return;

    if (loading) {
      addButtons.forEach((button) => {
        button.classList.add("loading");
      });
      return;
    }

    addButtons.forEach((button) => {
      const addButtonText = button.querySelector("span");
      const productBar = document.querySelector(".js-product-bar");
      if (preorder) {
        button.classList.add("js-preorder");
        if (addButtonText) {
          addButtonText.textContent = window.variantStrings.preorder;
        }
        if (productBar) {
          productBar.style.display = "block";
        }
      } else if (disable) {
        button.classList.add("js-back-in-stock");
        button.classList.remove("js-preorder");
        if (addButtonText) {
          addButtonText.textContent = window.variantStrings.backInStock;
        }

        if (productBar) {
          productBar.style.display = "none";
        }
      } else {
        button.classList.remove("js-back-in-stock");
        button.classList.remove("js-preorder");
        if (addButtonText) {
          addButtonText.textContent = window.variantStrings.addToBag;
        }

        if (productBar) {
          productBar.style.display = "block";
        }
      }
      button.classList.remove("loading");
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const productSection = document.querySelector(".js-product-section");
    if (!productSection) return;
    const addButtons = productSection.querySelectorAll('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButtons.length) return;
    addButtons.forEach((button) => {
      const addButtonText = button.querySelector("span");
      addButtonText.textContent = window.variantStrings.unavailable;
    });

    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);
